module.exports = __webpack_public_path__ + "img/card.f8e66143.svg";